export default {"src":"/_next/static/media/lifeins.84f364ea.svg","height":89,"width":89,"blurWidth":0,"blurHeight":0};